import Vue from 'vue'
import Vuex from 'vuex'
import Auth from './modules/Auth'
import M0001AdminUser from '@/components/functions/Admin/M0001User/M0001AdminUserStore'
import M0301AdminBidding from '@/components/functions/Admin/M0301Bidding/M0301AdminBiddingStore'
import M0303AdminBiddingGuide from '@/components/functions/Admin/M0303BiddingGuide/M0303AdminBiddingGuideStore'
import M0001SchoolUser from '@/components/functions/School/M0001User/M0001SchoolUserStore'
import M0301SchoolBidding from '@/components/functions/School/M0301Bidding/M0301SchoolBiddingStore'
import M0001TourCompanyUser from '@/components/functions/TourCompany/M0001User/M0001TourCompanyUserStore'
import M0301TourCompanyBidding from '@/components/functions/TourCompany/M0301Bidding/M0301TourCompanyBiddingStore'
import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

Vue.use(Vuex)
Vue.component('v-calendar', Calendar)
Vue.component('v-date-picker', DatePicker)

export default new Vuex.Store({
  modules: {
    Auth,
    M0001AdminUser,
    M0301AdminBidding,
    M0303AdminBiddingGuide,
    M0001SchoolUser,
    M0301SchoolBidding,
    M0001TourCompanyUser,
    M0301TourCompanyBidding
  }
})
